<mat-card class="cur-card">
    <mat-card-header>
        <mat-card-title>検索結果</mat-card-title>
    </mat-card-header>
    <mat-card-content>

        <div class="table-responsive" style="max-height: 800px; overflow: auto;">
            <table mat-table [dataSource]="dataSource" matSort #sort1="matSort" style="min-width: 1850px;">
                <ng-container matColumnDef="select">
                    <th mat-header-cell class="border-bottom-double text-center" *matHeaderCellDef style="width:2em">
                        <mat-checkbox *ngIf="true" (change)="$event ? masterToggle() : null;"
                            [checked]="selection.hasValue() && isAllSelected"
                            [indeterminate]="selection.hasValue() && !isAllSelected" color="primary">
                        </mat-checkbox>
                    </th>
                    <td mat-cell *matCellDef="let row">
                        <mat-checkbox color="primary" (change)="$event ? this.selection.toggle(row) : null;"
                            [checked]="selection.isSelected(row)">
                        </mat-checkbox>
                    </td>
                </ng-container>
                <ng-container matColumnDef="stpClsfy">
                    <th mat-header-cell class="border-bottom-double text-center" *matHeaderCellDef
                        style="min-width: 190px;">停止種別</th>
                    <td mat-cell *matCellDef="let row; let i = index">
                        <mat-select autocomplete="off" [(ngModel)]="row?.stpClsfy.codeValue"
                            [ngModelOptions]="{standalone: true}" class="disabled-select-color"
                            (valueChange)="onChangelpwaMethod(row)" id="stpClsfy" style="max-width: 315px;">
                            <mat-option></mat-option>
                            <mat-option *ngFor="let type of lpwaMethodList"
                                [value]="type.value">{{type.viewValue}}</mat-option>
                        </mat-select>
                    </td>
                </ng-container>
                <ng-container matColumnDef="base">
                    <th mat-sort-header mat-header-cell class="border-bottom-double" *matHeaderCellDef
                        style="min-width: 150px;">拠点</th>
                    <td mat-cell *matCellDef="let row">{{ row.base }}</td>
                </ng-container>
                <ng-container matColumnDef="tntsh">
                    <th mat-header-cell class="border-bottom-double text-center" *matHeaderCellDef
                        style="min-width: 105px; max-width: 175px;">作業担当者</th>
                    <td mat-cell *matCellDef="let row; let i = index">
                        <mat-select autocomplete="off" [(ngModel)]="row?.tntsh.codeValue"
                            [ngModelOptions]="{standalone: true}" class="disabled-select-color"
                            [disabled]="row?.stpClsfy.codeValue != '10'" required=true id="tntsh"
                            style="max-width: 175px;">
                            <mat-option></mat-option>
                            <mat-option *ngFor="let type of row.tntshList"
                                [value]="row?.stpClsfy.codeValue != '10'? '' : type.value">{{type.viewValue}}</mat-option>
                        </mat-select>
                    </td>
                </ng-container>
                <ng-container matColumnDef="suppntSpno">
                    <th mat-sort-header mat-header-cell class="border-bottom-double" *matHeaderCellDef
                        style="min-width: 120px;">供給地点特定番号</th>
                    <td mat-cell *matCellDef="let row">{{ row.suppntSpno }}</td>
                </ng-container>
                <ng-container matColumnDef="sougouHisougou.aname">
                    <th mat-sort-header mat-header-cell class="border-bottom-double" *matHeaderCellDef
                        style="min-width: 55px;">被総合</th>
                    <td mat-cell *matCellDef="let row" class="text-center">
                        {{row?.sougouHisougou.aname}}
                    </td>
                </ng-container>
                <ng-container matColumnDef="parentChild.aname">
                    <th mat-sort-header mat-header-cell class="border-bottom-double" *matHeaderCellDef
                        style="min-width: 55px;">親／子</th>
                    <td mat-cell *matCellDef="let row">
                        {{row.parentChild.aname}}
                    </td>
                </ng-container>
                <ng-container matColumnDef="supplydestinationAddr">
                    <th mat-sort-header mat-header-cell class="border-bottom-double" *matHeaderCellDef
                        style="min-width: 280px;">供給先住所</th>
                    <td mat-cell *matCellDef="let row">{{ row.supplydestinationAddr }}</td>
                </ng-container>
                <ng-container matColumnDef="gastype.aname">
                    <th mat-sort-header mat-header-cell class="border-bottom-double" *matHeaderCellDef
                        style="min-width: 66px;">ガス種</th>
                    <td mat-cell *matCellDef="let row">{{ row.gastype.aname }}</td>
                </ng-container>
                <ng-container matColumnDef="errorStr">
                    <th mat-sort-header mat-header-cell class="border-bottom-double" *matHeaderCellDef
                        style="min-width: 280px;">エラー内容</th>
                    <td mat-cell *matCellDef="let row">{{row.errorStr}}</td>
                </ng-container>
                <ng-container matColumnDef="supplystopResumeSts.aname">
                    <th mat-sort-header mat-header-cell class="border-bottom-double" *matHeaderCellDef
                        style="min-width: 95px;">供給停止再開<br>ステータス</th>
                    <td mat-cell *matCellDef="let row">
                        {{ row.supplystopResumeSts.aname }}
                    </td>
                </ng-container>
                <ng-container matColumnDef="forcedsuspensionTargetflag">
                    <th mat-sort-header mat-header-cell class="border-bottom-double" *matHeaderCellDef
                        style="min-width: 45px;">強制</th>
                    <td mat-cell *matCellDef="let row" class="text-center">
                        {{ row.forcedsuspensionTargetflag === '1'? '〇':'　' }}
                    </td>
                </ng-container>
                <ng-container matColumnDef="supplystopBreakPlndate">
                    <th mat-sort-header mat-header-cell class="border-bottom-double" *matHeaderCellDef
                        style="min-width: 95px;">供給停止<br>解約予定日</th>
                    <td mat-cell *matCellDef="let row">{{row.supplystopBreakPlndate | dateString}}</td>
                </ng-container>
                <ng-container matColumnDef="payCtrNo">
                    <th mat-sort-header mat-header-cell class="border-bottom-double" *matHeaderCellDef
                        style="min-width: 120px;">支払契約番号</th>
                    <td mat-cell *matCellDef="let row">{{ row.payCtrNo }}</td>
                </ng-container>
                <ng-container matColumnDef="visitName">
                    <th mat-sort-header mat-header-cell class="border-bottom-double" *matHeaderCellDef
                        style="min-width: 85px;">請求先名</th>
                    <td mat-cell *matCellDef="let row">{{ row.visitName }}</td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumnsCol; sticky: true"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumnsCol"></tr>
            </table>
        </div>
        <mat-paginator #paginator1 [pageSize]="10" showFirstLastButtons></mat-paginator>

        <div class="tw-flex tw-flex-row tw-box-border tw-justify-end tw-items-center tw-content-center">
            <mat-card-actions class="btn_area_right">
                <button type="button" mat-raised-button color="primary" class="btn" (click)="onClickRegist()"
                    [disabled]="selection.selected.length <= 0">登録</button>
            </mat-card-actions>
        </div>
    </mat-card-content>
</mat-card>